import apiUrl from './../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Utility from './../../../../utility/services/utility.service';
import Loader from './../../../../shared/components/loader';
import {Validator} from 'vee-validate';
import iptracker from '../../../../../views/components/commonfunction/iptracker';

export default {
  name: 'changeBookingmode',
  components: {
    Utility,
    iptracker,
    Loader
  },
  data: function() {
    return {
      awbnumber: '',
      invoicequantity:'',
      isLoading:false,
      showBookingMode:false,
      awbnumber:"",
      clientid:"",
      truckloadtype:"",
      clientbusinessaccountid:"",
      bookingmode:"",
      oldBookingMode:"",
      routemode:"",
      userdetail:{},
      comments:"",
      disablefield: false
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userdetail = userdetail;
  },
  methods: {
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.getCargoClientDetails();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    reset() {
      this.awbnumber = '';
      this.invoicequantity = '';
      this.showBookingMode = false;
      this.awbnumber = "";
      this.clientid = "";
      this.truckloadtype = "";
      this.clientbusinessaccountid = "";
      this.bookingmode = "";
      this.oldBookingMode = "";
      this.routemode = "";
      this.comments= "";
      this.disablefield = false;
    },
    async getCargoClientDetails(){
      try {
        let InputPayload = {
          awb : this.awbnumber
        }
        this.isLoading = true;
        let result = await Utility.getCargoClientDetails(InputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.disablefield = true;
          let clientDetails = result.data.data.ResultData;
          if(clientDetails.status=="Invalid"){
            this.$alertify.error("Shipment status is Invalid. So you can not update booking mode.");
            return false;
          }else if(clientDetails.bookingstatus!="Complete"){
            this.$alertify.error("AWB booking status is Pending/Rapid. Please complete the booking process.");
            return false;
          }else{
            let bookingmode;
            if(clientDetails.BookingMode.toLowerCase() == 'to pay' || clientDetails.BookingMode.toLowerCase() == 'topay'){
                bookingmode = 'To Pay';
            }else{
              bookingmode = clientDetails.BookingMode
            }
            this.showBookingMode = true;
            this.bookingmode = bookingmode;
            this.oldBookingMode = bookingmode;
            this.clientid = clientDetails.ClientID;
            this.truckloadtype = clientDetails.TruckLoadType;
            this.routemode = clientDetails.RouteMode;
            this.clientbusinessaccountid = clientDetails.ClientBusinessAccountId;
          }
        } else {
            this.disablefield = false;
            this.$alert(result.data.message,"","error");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    getTraceIP(awbno) {
      let data =
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/changebookingmode',
          "meta" : {
            "event" : `Change Booking Mode`,
            "data" : awbno
          }
      }
      let result = iptracker.getTraceIP(data);
    },
    onSubmitSave: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.UpdateBookingMode();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async UpdateBookingMode(){
      try {
        this.isLoading = true;
        let InputPayload = {};
        InputPayload.awbnumber =   this.awbnumber;
        InputPayload.clientid = this.clientid;
        InputPayload.truckloadtype = this.truckloadtype;
        InputPayload.clientbusinessaccountid = this.clientbusinessaccountid;
        InputPayload.bookingmode = this.bookingmode;
        InputPayload.routemode = this.routemode;
        InputPayload.username = this.userName;
        InputPayload.comments = this.comments;
        let result = await Utility.changeBookingMode(InputPayload);
        this.isLoading = false;
          if (result.data.code == 200) {
            this.oldBookingMode = this.bookingmode;
            this.comments = "";
            this.$validator.reset();
            this.getTraceIP(InputPayload);
            this.$alert(result.data.message,"","success");
        } else {
            this.$alert(result.data.message,"","error");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/updateBookingDetails/changebookingmode/changebookingmode.component.js